import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../../utils/apiConfig';

/**
 * WorkforceStatus - Widget "Répartition effectif" pour Admin
 */
const WorkforceStatus = ({ token }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWorkforce = async () => {
      if (!token) return;

      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/dashboard/workforce-status`,
          {
            headers: { 'Authorization': `Bearer ${token}` }
          }
        );

        if (!response.ok) throw new Error('Erreur de chargement');

        const result = await response.json();
        setData(result.success ? result.data : null);
      } catch (err) {
        console.error('Erreur fetch workforce:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchWorkforce();
  }, [token]);

  if (loading) {
    return (
      <div style={styles.container}>
        <h4 style={styles.title}>Répartition effectif</h4>
        <div style={styles.loading}>Chargement...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.container}>
        <h4 style={styles.title}>Répartition effectif</h4>
        <div style={styles.error}>{error}</div>
      </div>
    );
  }

  if (!data) {
    return (
      <div style={styles.container}>
        <h4 style={styles.title}>Répartition effectif</h4>
        <div style={styles.empty}>Données non disponibles</div>
      </div>
    );
  }

  const { total, on_mission, available, absent, percentages } = data;

  return (
    <div style={styles.container}>
      <h4 style={styles.title}>Répartition effectif</h4>

      <div style={styles.totalBadge}>
        Total : <strong>{total}</strong> employés
      </div>

      <div style={styles.statsGrid}>
        <div style={{ ...styles.statCard, borderColor: '#28a745' }}>
          <span style={styles.statValue}>{on_mission}</span>
          <span style={styles.statPercent}>({percentages.on_mission}%)</span>
          <span style={styles.statLabel}>En mission</span>
        </div>
        <div style={{ ...styles.statCard, borderColor: '#17a2b8' }}>
          <span style={styles.statValue}>{available}</span>
          <span style={styles.statPercent}>({percentages.available}%)</span>
          <span style={styles.statLabel}>Disponibles</span>
        </div>
        <div style={{ ...styles.statCard, borderColor: '#ffc107' }}>
          <span style={styles.statValue}>{absent}</span>
          <span style={styles.statPercent}>({percentages.absent}%)</span>
          <span style={styles.statLabel}>Absents</span>
        </div>
      </div>

      {/* Barre de répartition visuelle */}
      <div style={styles.barContainer}>
        <div
          style={{
            ...styles.barSegment,
            width: `${percentages.on_mission}%`,
            backgroundColor: '#28a745'
          }}
        />
        <div
          style={{
            ...styles.barSegment,
            width: `${percentages.available}%`,
            backgroundColor: '#17a2b8'
          }}
        />
        <div
          style={{
            ...styles.barSegment,
            width: `${percentages.absent}%`,
            backgroundColor: '#ffc107'
          }}
        />
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    height: '100%',
    boxSizing: 'border-box'
  },
  title: {
    margin: '0 0 16px 0',
    fontSize: '1.1rem',
    fontWeight: '600',
    color: '#1a1a2e'
  },
  totalBadge: {
    display: 'inline-block',
    padding: '6px 12px',
    backgroundColor: '#f8f9fa',
    borderRadius: '6px',
    fontSize: '0.9rem',
    color: '#495057',
    marginBottom: '16px'
  },
  loading: {
    textAlign: 'center',
    padding: '30px',
    color: '#6c757d'
  },
  error: {
    padding: '20px',
    backgroundColor: '#fff5f5',
    borderRadius: '8px',
    color: '#dc3545',
    textAlign: 'center'
  },
  empty: {
    textAlign: 'center',
    padding: '30px',
    color: '#6c757d'
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '12px',
    marginBottom: '16px'
  },
  statCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '12px 8px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    borderLeft: '4px solid'
  },
  statValue: {
    fontSize: '1.8rem',
    fontWeight: '700',
    color: '#1a1a2e',
    lineHeight: 1
  },
  statPercent: {
    fontSize: '0.8rem',
    color: '#6c757d',
    marginTop: '2px'
  },
  statLabel: {
    fontSize: '0.8rem',
    color: '#495057',
    marginTop: '6px',
    fontWeight: '500'
  },
  barContainer: {
    display: 'flex',
    height: '10px',
    borderRadius: '5px',
    overflow: 'hidden',
    backgroundColor: '#e9ecef'
  },
  barSegment: {
    height: '100%',
    transition: 'width 0.3s ease'
  }
};

export default WorkforceStatus;
